import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

type Props = { API: string };
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });

const s: any = {
  label: { fontSize: 12, color: '#6b7280', marginBottom: 4, display: 'block' },
  input: { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' as any, fontFamily: 'inherit', outline: 'none' },
  card: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 12 },
  btn: { padding: '7px 14px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', color: '#374151', fontSize: 13, cursor: 'pointer', fontWeight: 500 },
  btnPrimary: { padding: '7px 16px', borderRadius: 6, border: '1px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontSize: 13, cursor: 'pointer', fontWeight: 600 },
};

export default function PrestaShopSettings({ API }: Props) {
  const [status, setStatus] = useState<any>(null);
  const [shopUrl, setShopUrl] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState<any>(null);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  const loadStatus = () => {
    axios.get(API + '/settings/prestashop', { headers: auth() })
      .then((r: any) => { setStatus(r.data); if (r.data && r.data.shop_url) setShopUrl(r.data.shop_url); })
      .catch((e: any) => setError((e.response && e.response.data && e.response.data.detail) || 'Nie udało się pobrać statusu połączenia.'));
  };

  useEffect(() => {
    loadStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const connect = () => {
    setSaving(true); setError(''); setMsg(''); setTestResult(null);
    axios.post(API + '/settings/prestashop/connect', { shop_url: shopUrl, api_key: apiKey }, { headers: auth() })
      .then((r: any) => {
        setStatus(r.data);
        setMsg('Połączenie zapisane — klucz API działa.');
        setApiKey('');
        setTestResult({ ok: true, text: 'PrestaShop zaakceptował klucz (pobranie produktów przebiegło pomyślnie).' });
      })
      .catch((e: any) => setError((e.response && e.response.data && e.response.data.detail) || 'Nie udało się połączyć ze sklepem.'))
      .finally(() => setSaving(false));
  };

  const test = () => {
    setTesting(true); setError(''); setMsg(''); setTestResult(null);
    axios.post(API + '/settings/prestashop/test', {}, { headers: auth() })
      .then((r: any) => {
        const miss: string[] = (r.data && r.data.missing_resources) || [];
        const base = 'Połączenie działa.' + ((r.data && r.data.sample_products != null) ? (' Przykładowych produktów: ' + r.data.sample_products + '.') : '');
        if (miss.length > 0) {
          setTestResult({ ok: false, text: base + ' Brak dostępu do zasobów: ' + miss.join(', ') + '. Bez specific_prices ceny nie uwzględniają rabatów — dopisz uprawnienie GET w PrestaShop (Zaawansowane parametry -> Webservice -> edycja klucza) i przetestuj ponownie.' });
        } else {
          setTestResult({ ok: true, text: base });
        }
      })
      .catch((e: any) => setTestResult({ ok: false, text: (e.response && e.response.data && e.response.data.detail) || 'Test nieudany.' }))
      .finally(() => setTesting(false));
  };

  const disconnect = () => {
    if (!window.confirm('Rozłączyć sklep PrestaShop? Zamówienia ręczne utworzone wcześniej pozostaną w module Zamówienia.')) return;
    setError(''); setMsg(''); setTestResult(null);
    axios.delete(API + '/settings/prestashop', { headers: auth() })
      .then(() => { setStatus({ configured: false }); setApiKey(''); setMsg('Sklep rozłączony.'); })
      .catch((e: any) => setError((e.response && e.response.data && e.response.data.detail) || 'Nie udało się rozłączyć sklepu.'));
  };

  const configured = !!(status && status.configured);
  const canSave = !!shopUrl && !!apiKey;

  return (
    <div>
      <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Sklep PrestaShop — ręczne zamówienia</h2>

      {error ? (<div style={{ background: '#fef2f2', border: '1px solid #fecdd3', color: '#b91c1c', borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 12 }}>{error}</div>) : null}
      {msg ? (<div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#15803d', borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 12 }}>{msg}</div>) : null}
      {testResult ? (
        <div style={{ background: testResult.ok ? '#f0fdf4' : '#fef2f2', border: '1px solid ' + (testResult.ok ? '#bbf7d0' : '#fecdd3'), borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 12, color: testResult.ok ? '#15803d' : '#b91c1c' }}>
          {testResult.text}
        </div>
      ) : null}

      <div style={s.card}>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Status połączenia</div>
        {status === null ? (
          <div style={{ fontSize: 13, color: '#6b7280' }}>Ładowanie…</div>
        ) : configured ? (
          <div style={{ fontSize: 13 }}>
            <div>Sklep: <b>{status.shop_url}</b></div>
            <div style={{ color: '#6b7280', marginTop: 4 }}>Klucz API: <code>{status.key_masked}</code></div>
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <button onClick={test} disabled={testing} style={{ ...s.btn, opacity: testing ? 0.5 : 1 }}>{testing ? '⏳ Testowanie…' : 'Testuj połączenie'}</button>
              <button onClick={disconnect} style={{ ...s.btn, color: '#dc2626', borderColor: '#fca5a5' }}>Rozłącz sklep</button>
            </div>
          </div>
        ) : (
          <div style={{ fontSize: 13, color: '#6b7280' }}>Sklep nie jest połączony.</div>
        )}
      </div>

      <div style={s.card}>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>{configured ? 'Zmień dane połączenia' : 'Połącz sklep'}</div>
        <div style={{ display: 'grid', gap: 10, maxWidth: 520 }}>
          <div>
            <label style={s.label}>Adres sklepu</label>
            <input value={shopUrl} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setShopUrl(e.target.value)} placeholder="https://twojsklep.pl" style={s.input} />
          </div>
          <div>
            <label style={s.label}>Klucz API (webservice)</label>
            <input type="password" value={apiKey} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setApiKey(e.target.value)} placeholder={configured ? '— zostaw puste, jeśli działa —' : '32-znakowy klucz z panelu sklepu'} style={s.input} />
          </div>
          <div>
            <button onClick={connect} disabled={saving || !canSave} style={{ ...s.btnPrimary, opacity: (saving || !canSave) ? 0.5 : 1, cursor: (saving || !canSave) ? 'not-allowed' : 'pointer' }}>
              {saving ? '⏳ Zapisywanie…' : 'Zapisz i sprawdź połączenie'}
            </button>
          </div>
        </div>
      </div>

      <div style={{ ...s.card, fontSize: 12, color: '#6b7280', lineHeight: 1.6 }}>
        <b style={{ color: '#374151' }}>Jak wygenerować klucz API w PrestaShop?</b><br />
        Panel sklepu → <b>Zaawansowane parametry → Ustawienia API</b> (lub „Webservice”): włącz API, dodaj nowy klucz
        i zaznacz uprawnienia <b>GET</b> dla zasobów: products, specific_prices, taxes, tax_rules, carriers.
        Wklej klucz powyżej. Ceny produktów pobieramy jako brutto (netto + VAT − rabaty produktowe ze sklepu).
      </div>
    </div>
  );
}
